import React from 'react';
import { DescriptedDefinitionList } from '../../../_lib/components/DefinitionList';
import { Hyperlink } from '../../atoms/Hyperlink';
import { Image, ImageModifier } from '../Image';
import { Namespace } from '../../../translation/namespace';
import bem from '../../../lib/bemUtils/bem';
import { PersonInfoCardData, PersonInfoCardModifier } from './PersonInfoCard.types';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type PersonInfoCard = {
  infoCardData?: PersonInfoCardData;
  modifier?: Modifier<PersonInfoCardModifier>;
  stylingContent?: 'normal' | 'dark';
  headlineHierarchy?: number;
};

export function PersonInfoCard({
  infoCardData,
  modifier,
  stylingContent = 'dark',
  headlineHierarchy = 2,
}: PersonInfoCard) {
  const { t } = useSonTranslation('PersonInfoCard');

  if (!infoCardData) {
    return null;
  }

  const getHeadline = () => ({
    text: infoCardData.profileName,
    subheadline: infoCardData.roleNames,
    href: infoCardData.profileLink.url,
  });

  const getItems = () => [
    {
      term: t(`${Namespace.glossary}:institution`),
      description: infoCardData.institution,
    },
    {
      term: t(`${Namespace.glossary}:organisationalUnit`),
      description: infoCardData.orgUnit,
    },
    {
      term: t(`${Namespace.glossary}:phone`),
      description: infoCardData.phoneLink ? infoCardData.phoneLink.name : null,
      href: infoCardData.phoneLink ? infoCardData.phoneLink.url : null,
    },
    {
      term: t(`${Namespace.glossary}:mail`),
      description: infoCardData.emailLink ? infoCardData.emailLink.name : null,
      href: infoCardData.emailLink ? infoCardData.emailLink.url : null,
    },
    {
      term: t(`${Namespace.glossary}:room`),
      description: infoCardData.room,
    },
    {
      term: t(`${Namespace.glossary}:serviceLocation`),
      /* infoCardData.location should be renamed to infoCardData.serviceLocation to
       properly distinguish location and serviceLocation
       this will also need a lot of backend work see SON-9822 */
      description: infoCardData.location,
    },
  ];

  return (
    <div className={bem('person-info-card', modifier)}>
      <Hyperlink to={infoCardData.profileLink.url} className="person-info-card__image-link">
        <Image
          image={infoCardData.profileImageUrl}
          customAltText={t('profilePage') + infoCardData.profileName}
          modifier={ImageModifier.CENTER_HORIZONTAL}
        />
      </Hyperlink>
      <DescriptedDefinitionList
        headline={getHeadline()}
        headlineHierarchy={headlineHierarchy}
        styling={stylingContent}
        definitionTerms={getItems()}
      />
    </div>
  );
}
